import { Injectable } from '@angular/core';

import { getEventData } from '../object-data/im-object-data.helper';
import { eventServerError } from '../tracking-common/im-tracking-common.helper';

import { ShippingMethod } from '@api/shipping/models/shipping.model';
import { DroppointListsDetail } from '@api/store-locator/droppoint-lists/models/droppoint-lists.models';
import { PhysicalStoreDetail } from '@api/store-locator/physical-store/models/physical-store.models';
import { AnalitycsEvent, CustomData } from '@shared/analytics/models/analytics/analytics.models';
import { DeliveryShippingTypeString, EventData } from '@shared/analytics/models/general/general.models';

@Injectable()
export class ImShippingService {
    public newAddress: boolean = true;

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    constructor() {}

    public setIsNewAddress(value: boolean) {
        this.newAddress = value;
    }

    public selectShipping(method: ShippingMethod, action: 'seleccionar_envio_ok' | 'seleccionar_envio'): EventData {
        let methodName: string = method.kind;

        if (method.kind === 'delivery') {
            methodName = method.dbcode === 'Standard' ? DeliveryShippingTypeString.normal : DeliveryShippingTypeString.express;
        }

        const eventData: EventData = {
            cf: 'checkout',
            category: 'envio',
            action,
            label: methodName,
        };

        return eventData;
    }

    public selectedFavorite(storeId: string): AnalitycsEvent {
        const eventData: EventData = {
            cf: 'checkout',
            category: 'envio',
            action: 'seleccionar_tienda_favorita',
            label: storeId,
        };
        const customData: CustomData = {
            store: {
                storeId,
            },
        };

        return { eventData, customData };
    }

    public createEvent(cf: string, action: string, label: number | string, customData?: CustomData): AnalitycsEvent {
        const eventData: EventData = {
            cf,
            category: 'envio',
            action,
            label,
        };
        return {
            eventData,
            ...customData ? { customData } : {},
        };
    }

    private getZipcode(shippingData: any): string | undefined {
        if (shippingData && 'zipCode' in shippingData) {
            return shippingData.zipCode;
        }
        return undefined;
    }

    // Usar tambien para modificar la direccion
    public addAddress(shippingData): { eventData: EventData; customData: CustomData } {
        const zipcode = this.getZipcode(shippingData);
        let action: string = 'anadir_direccion_ok';
        // Para distinguir si se edita o se anade una direccion se  distingue si aparecen X en el div
        if (!this.newAddress) {
            action = 'modificar_direccion_ok';
        }

        const eventData = getEventData('perfil_comprador', 'envio', action, zipcode);

        const customData: CustomData = {
            store: {
                zipCode: zipcode,
            },
        };

        return { eventData, customData };
    }

    public createPickupSelectEvent(
        shippingMethod: ShippingMethod,
        viewMode: string,
        pickupDetails: DroppointListsDetail | PhysicalStoreDetail
    ) {
        const pickupType = shippingMethod?.kind === 'pickup' ? 'tienda' : 'droppoint';
        const eventType = pickupType === 'tienda' ? 'tiendas' : 'droppoint';
        const displayMode = {
            list: `seleccionar_${pickupType}_lista`,
            map: `seleccionar_${pickupType}_mapa`,
        };
        const eventData = {
            cf: `localizador_${eventType}`,
            action: displayMode[viewMode],
            label: pickupDetails.id,
        };
        const customData = {
            store:
                pickupType === 'tienda' ? { storeId: pickupDetails.id } : { dropPoint: pickupDetails.id },
        };
        return { eventData, customData };
    }

    public createServer(form: any, error: any): EventData {
        const cf = 'perfil_comprador';
        const category = 'envio';
        return eventServerError(cf, category, form, error);
    }
}
